import { createContext, useContext } from 'react'
import type { LookupParcelByRobustIdResult } from '@/modules/properties/use-cases'

export type ParcelInfoCacheContextValue = {
  get: (robustId: string) => LookupParcelByRobustIdResult | null | undefined
  set: (robustId: string, info: LookupParcelByRobustIdResult | null) => void
  clear: () => void
}

export const ParcelInfoCacheContext = createContext<ParcelInfoCacheContextValue | null>(null)

export function useParcelInfoCache(): ParcelInfoCacheContextValue {
  const ctx = useContext(ParcelInfoCacheContext)
  if (!ctx) throw new Error('useParcelInfoCache must be used within <ParcelInfoCacheProvider>')
  return ctx
}
